// extracted by mini-css-extract-plugin
export default {"root":"tKLoKiA6PIVNqmQ0omYCMA=="};